/*
    The AppStateContext is used to manage a sort of global state for the application.
    As AppState moves from one state to another, the individual components will react; 
    showing, or hiding, growing, shrinking etc. As this is too much to manage from a parent,
    the behaviour will be delegated to the individual components.

    The AppStateContext is accessible throughout the application via the useAppState hook, and
    provides some sensible defaults and helpers.
*/
import { type AppState } from "@/types/SharedTypes";
import { createContext, useContext } from "react";

interface AppStateContextType {
    appState: AppState;
    urlPath: string;
    setAppState: (state: AppState) => void;
}

export const AppStateContext = createContext<AppStateContextType>({
    appState: "initializing" as AppState,
    urlPath: '',
    setAppState: () => { },
});

export const useAppState = () => useContext(AppStateContext);